import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-pending-orders',
  standalone: true,
  imports: [CommonModule, NgFor, FormsModule],
  templateUrl: './pending-orders.component.html',
  styleUrls: ['./pending-orders.component.css']
})
export class PendingOrdersComponent {
  @Input() orders: any[] = [];
  @Output() orderUpdated = new EventEmitter<any>();

  isModalOpen = false;
  selectedOrder: any = null;
  quantityForApproval: number | null = null;
  maxApprovableQuantity = 0;

  /** Opens modal for approval quantity entry */
  openApprovalModal(order: any): void {
    console.log('Opening approval modal for pending order:', order);
    this.selectedOrder = { ...order };

    // Remaining quantity = total - (ready + approved)
    this.maxApprovableQuantity =
      Number(order.quantity) -
      (Number(order.ready_quantity) + Number(order.approved_quantity));

    this.quantityForApproval = null;
    this.isModalOpen = true;
  }

  /** Closes modal */
  closeModal(): void {
    this.isModalOpen = false;
    this.selectedOrder = null;
    this.quantityForApproval = null;
  }

  /** Submits for approval */
  submitForApproval(): void {
    if (!this.selectedOrder || this.quantityForApproval === null || this.quantityForApproval <= 0) {
      alert('Please enter a valid quantity.');
      return;
    }

    if (this.quantityForApproval > this.maxApprovableQuantity) {
      alert(`Quantity cannot exceed the remaining ${this.maxApprovableQuantity} items.`);
      return;
    }

    const newReadyQty = Number(this.selectedOrder.ready_quantity) + Number(this.quantityForApproval);

    const updatedData = {
      orderId: this.selectedOrder.id,
      ready_quantity: newReadyQty,
      ordc_request_status: 'approval_waiting',
    };

    console.log('Updated pending order data:', updatedData);

    this.orderUpdated.emit(updatedData);
    this.closeModal();
  }
}
